import { render, staticRenderFns } from "./QuestionTab.vue?vue&type=template&id=39e501de&scoped=true&"
import script from "./QuestionTab.vue?vue&type=script&lang=js&"
export * from "./QuestionTab.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTab.vue?vue&type=style&index=0&lang=css&"
import style1 from "./QuestionTab.vue?vue&type=style&index=1&id=39e501de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e501de",
  null
  
)

export default component.exports